import { memo } from 'react';
import {
  ToolbarCheckCircleIcons,
  ToolbarClearIcons,
  ToolbarMailIcons,
} from '../../../../../../icons/icons';
import { ActionButton } from './ActionButton';
import { UnsuccessfulApplicantsActionsProps } from './interfaces';
import { Box, ButtonBase, Stack, Typography } from '@mui/material';

export const UnsuccessfulApplicantsActions =
  memo<UnsuccessfulApplicantsActionsProps>(
    ({
      selectAllUnsuccessful,
      handleClearSelected,
      isClearDisabled,
      handleSendEmailToSelected,
      isSendEmailDisabled,
      selectedApplicantCount,
    }) => (
      <Stack direction="row" alignItems="center" spacing={0.5} sx={{ ml: 0.25, pl: 0.25 }}>
        <ActionButton
          onClick={selectAllUnsuccessful}
          variant="blue"
          icon={
            <Box sx={{ display: 'flex', transition: 'transform 0.2s' }}>
              <ToolbarCheckCircleIcons className="w-3.5 h-3.5" />
            </Box>
          }
          label="Select All"
          title="Select all candidates in Unsuccessful-Pending status (emails not yet sent)"
          hideOnSmall
        />

        <ActionButton
          onClick={handleClearSelected}
          disabled={isClearDisabled}
          variant="red"
          icon={
            <Box sx={{ display: 'flex', transition: 'transform 0.2s' }}>
              <ToolbarClearIcons className="w-3.5 h-3.5" />
            </Box>
          }
          label="Clear"
          title="Clear selection"
          hideOnSmall
        />

        <ButtonBase
          onClick={handleSendEmailToSelected}
          disabled={isSendEmailDisabled}
          title={`Send emails to ${selectedApplicantCount} selected candidates`}
          aria-label={`Send emails to ${selectedApplicantCount} selected candidates`}
          sx={{
            height: { xs: 28, sm: 34 },
            px: { xs: 1.5, sm: 2 },
            borderRadius: '8px',
            transition: 'all 0.3s',
            display: 'flex',
            alignItems: 'center',
            gap: { xs: 0.5, sm: 1 },
            fontWeight: 500,
            fontSize: { xs: '12px', sm: '13px' },
            whiteSpace: 'nowrap',
            ...(isSendEmailDisabled
              ? {
                  bgcolor: 'transparent',
                  color: '#cbd5e1',
                  cursor: 'not-allowed',
                  opacity: 0.4,
                  pointerEvents: 'none',
                }
              : {
                  bgcolor: '#fef2f2',
                  color: '#dc2626',
                  boxShadow: '0 1px 2px rgba(220,38,38,0.1)',
                  '&:hover': { bgcolor: 'rgba(254,226,226,0.8)' },
                  '&:active': { bgcolor: 'rgba(254,202,202,0.5)' },
                }),
          }}
        >
          <Box
            sx={{
              display: 'flex',
              transition: 'transform 0.2s',
              ...(selectedApplicantCount > 0 && {
                '.MuiButtonBase-root:hover &': { transform: 'rotate(6deg)' },
              }),
            }}
          >
            <ToolbarMailIcons className="w-3.5 h-3.5" />
          </Box>
          <Typography
            component="span"
            sx={{
              fontSize: 'inherit',
              fontWeight: 'inherit',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            Email ({selectedApplicantCount})
          </Typography>
        </ButtonBase>
      </Stack>
    ),
  );

UnsuccessfulApplicantsActions.displayName = 'UnsuccessfulApplicantsActions';
